__turbopack_context__.v({
  "track": "VillaHostCityCarousel-module-scss-module__7j8nfq__track",
  "villa-host-city-marquee": "VillaHostCityCarousel-module-scss-module__7j8nfq__villa-host-city-marquee",
});
